import { Routes } from '@angular/router';
import { CreateDriverComponent } from './create-driver/create-driver.component';
export const ExtraRoutes: Routes = [
    /* {
        path: '',
        component: CreateDriverComponent
    }, */
];
